// Re-export from canonical location — src/components/Profiles/shared/widgets/registry/
// Import directly from specific files (not the barrel) to avoid circular dependency:
// barrel → widgetRegistry → widgets → PlaysSection → widgetRenderer shim → barrel
export {
  WidgetRenderer,
  toProfileWidget,
} from './widgets/registry/WidgetRenderer';

export {
  groupWidgetsByCodeSet,
  buildOrderedSections,
} from './widgets/registry/widgetRegistry';

export type { CodeSetGroup, ProfileSection } from './widgets/registry/types';

// Side-effect: importing this module triggers the widget registry initializer
// via the import chain into widgetRegistry.tsx.
import './widgets/registry/widgetRegistry';
